import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate } from 'react-router-dom';

import NoSubsMonkey from '../../assets/img/no_subs_monkey.svg';
import * as routing from '../../constants/Routing';
import { useRetrieveOrganization } from '../../hooks/organization/useRetrieveOrganization';
import { useRetrieveUser } from '../../hooks/user/useRetrieveUser';
import Button from '../../react-components/Button';
import Text from '../../react-components/Text';
import { OnboardingComponent } from '../onboarding';

export const ShallNotPassComponent = () => {
  const navigate = useNavigate();
  const { data: organization } = useRetrieveOrganization();
  const { data: user } = useRetrieveUser();

  if (!organization?.active && user && organization?.isOwner(user.id)) {
    return <OnboardingComponent />;
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      wrap="nowrap"
      style={{ minHeight: `400px`, overflowY: `auto` }}
    >
      <Grid item>
        <Text variant="h5" style={{ textAlign: `center` }} intlId="shallnotpass.title" />
      </Grid>

      <VSpacer small />

      <Grid item>
        <Text variant="body-large" style={{ textAlign: `center` }} intlId="shallnotpass.info.1" />
      </Grid>

      <VSpacer small />

      <Grid item container justifyContent="center">
        <img alt="" src={NoSubsMonkey} style={{ width: `400px` }} draggable="false" />
      </Grid>

      <VSpacer small />

      <Grid item style={{ maxWidth: `200px` }}>
        <Button
          variant="default"
          intlId="shallnotpass.button"
          onClick={() => {
            navigate(routing.SETTINGS.BILLING.SUBSCRIPTION);
          }}
        />
      </Grid>
    </Grid>
  );
};
